import React, {ReactNode} from 'react';
import classNames from 'classnames';
import {Flex} from '@priority-software/priority-style-react';
import styles from '../../style/MenuItem.module.scss';
import {withHover, InjectedHoverProps} from '../../../../components/Common/HOC/withHover';
import {withTooltip} from '../../../../components/Common/HOC/Custom/withTooltip';
import {Label} from '../../../../components/Common/Label';

interface menuItemProps extends InjectedHoverProps {
    title: ReactNode;
    label?: ReactNode;
    shortkey?: string;
    disabled?: boolean;
    checkOption?: () => boolean;
    hoverComp?: any;
    className?: string;
    isHovering?: boolean;
}

const MenuItemComp = ({
    title,
    shortkey,
    disabled,
    label,
    isHovering,
    hoverComp,
    className,
    checkOption
}: menuItemProps) => {
    const renderContent = () => {
        const isDisabeld =
            disabled === true || disabled === false ? disabled : checkOption && !checkOption();

        const classes = classNames(
            styles.menuItem,
            {
                [styles.disabled]: isDisabeld
            },
            'item-without-hover'
        );

        return (
            <>
                <div className={classes}>{title}</div>
                <div className={classNames(styles.actionContainer, styles.flexEnd)}>
                    {label && <span className={styles.menuText}>{label}</span>}
                    {shortkey && (
                        <span className={styles.shortkey}>
                            [
                            <Label tag="div" textColor="secondary-300" skin="label-1" inline>
                                {shortkey}
                            </Label>
                            ]
                        </span>
                    )}
                </div>
            </>
        );
    };

    const renderHoverComp = () => (
        <>
            <div className={styles.menuItem}>{title}</div>
            {hoverComp}
        </>
    );

    return (
        <Flex
            componentClasses={classNames(styles.component, className)}
            justifyContent="space-between"
        >
            {isHovering && hoverComp ? renderHoverComp() : renderContent()}
        </Flex>
    );
};

/**
 * @param title string
 * @param shortkey string (optional)
 * @param label string (optional)
 * @param hoverComp any (optional)
 * @param disabled boolean (optional)
 **/
export const MenuItem = withHover(withTooltip(MenuItemComp));
